import { render, staticRenderFns } from "./infoCampaign.vue?vue&type=template&id=54275d1e&"
import script from "./infoCampaign.vue?vue&type=script&lang=js&"
export * from "./infoCampaign.vue?vue&type=script&lang=js&"
import style0 from "./infoCampaign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports